module.exports = __webpack_public_path__ + "img/ic_star_on.fc182b53.svg";